import './title.css'

export default function Title({ children }) {

  return (
    <h1 className="inventoryTitle">{children}</h1>
  );
}
